<template>
  <div ref="container">
    <slot />
  </div>
</template>

<script setup>
import { onMounted, ref, watch, reactive } from 'vue';
import { store } from '@/store/steps';

const props = defineProps({
  root: { type: Object, default: null },
  top: { type: Number, default: 0 },
  bottom: { type: Number, default: 0 },
  increments: { type: Number, default: 100 },
  value: { type: Number, default: undefined }
});

const container = ref(null);
const steps = reactive([]);
const threshold = [];
const nodes = ref([]);
const intersectionObservers = ref([]);

const mostInView = () => {
  let maxRatio = 0;
  let maxIndex = 0;
  steps.forEach((step, index) => {
    if (step > maxRatio) {
      maxRatio = step;
      maxIndex = index;
    }
  });

  if (maxRatio > 0) {
    store.updateIndex(maxIndex);
  } else {
    // store.updateIndex(0);
  }
};

const createObserver = (node, index) => {
  const handleIntersect = (entries) => {
    const entry = entries[0];
    const ratio = entry.intersectionRatio;
    steps[index] = ratio;
    mostInView();
  };

  const marginTop = props.top ? props.top * -1 : 0;
  const marginBottom = props.bottom ? props.bottom * -1 : 0;
  const rootMargin = `${marginTop}px 0px ${marginBottom}px 0px`;
  const options = { root: props.root, rootMargin, threshold };

  if (intersectionObservers.value[index]) {
    intersectionObservers.value[index].disconnect();
  }

  const observer = new IntersectionObserver(handleIntersect, options);
  observer.observe(node);
  intersectionObservers.value[index] = observer;
};

onMounted(() => {
  for (let i = 0; i <= props.increments; i++) {
    threshold.push(i / props.increments);
  }
  nodes.value = Array.from(container.value.children); // Assumes direct children, adjust selector as needed

    nodes.value.forEach((node, index) => {
      if (node.tagName !== 'IFRAME') { // Adjust as necessary for your needs
        createObserver(node, index);
      }
    });
});
</script>
